import SelectCheckbox from './FullNameCell';

export default SelectCheckbox;
